export let dataProps = {
    id: 0,
    category_name: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/saleCategory/properties.js